// see active/lib/activities/workouts.rb for a full list
export const WORKOUT_TYPES = {
  runDefault: 0,
  runRace: 1,
  runLong: 2,
  runInterval: 3,
  rideDefault: 10,
  rideRace: 11,
  rideInterval: 12
} as const;

export const ATHLETE_TYPES = {
  cyclist: 0,
  runner: 1
} as const;

// These are the route types as specified in Active
//
// Based on routing thrift definition
// https://github.com/strava/routing/blob/e0f8503caac4facef8df0955f314b4be521385d8/routing-interface/src/main/thrift/routing.thrift#L18-L55
export const ROUTE_TYPES = {
  ride: 1,
  run: 2,
  walk: 3,
  hike: 4,
  trailRun: 5,
  gravelRide: 6,
  mountainBikeRide: 7,
  eMountainBikeRide: 8,
  eBikeRide: 9,
  swim: 10,
  kayak: 11,
  golf: 12,
  sail: 13,
  canoe: 14,
  alpineSki: 15,
  backcountrySki: 16,
  iceSkate: 17,
  inlineSkate: 18,
  handcycle: 19,
  kitesurf: 20,
  nordicSki: 21,
  rockClimbing: 22,
  rollerSki: 23,
  rowing: 24,
  skateboard: 25,
  snowshoe: 26,
  standUpPaddle: 27,
  surfing: 28,
  velomobile: 29,
  windsurf: 30,
  wheelchair: 31
} as const;

// Based on routing thrift definition
// https://github.com/strava/routing/blob/4476c6235a2c9ee4ba9804d95fb92195e05c18d3/routing-interface/src/main/thrift/routing.thrift#L65-L69
export const SURFACE_TYPE = {
  paved: 1,
  unpaved: 2,
  unknown: 3
} as const;
